import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

/** Generated by scripts/generate-contours.mjs. */
const CONTOURS_URL = "url(/textures/contours.svg)";

const FADES = {
  bottom: "linear-gradient(to bottom, #000 25%, transparent)",
  top: "linear-gradient(to top, #000 25%, transparent)",
  none: undefined,
} as const;

interface TopoTextureProps {
  /**
   * Position, size, color (via `text-*`) and strength (via `opacity-*`).
   * The parent must be positioned; content that should sit above the lines
   * needs to come later in the DOM and be positioned too.
   */
  className?: string;
  /** Which way the lines fade out. */
  fade?: keyof typeof FADES;
  /** CSS mask-size of the contour image (`cover`, `720px`, …). */
  size?: string;
  /** CSS mask-position of the contour image. */
  position?: string;
}

/**
 * The "vrstevnice" signature: topographic contour lines drawn in currentColor,
 * so one texture works in both themes and any accent. Purely decorative.
 */
export function TopoTexture({
  className,
  fade = "bottom",
  size = "cover",
  position = "center",
}: TopoTextureProps) {
  const fadeMask = FADES[fade];
  const outer: CSSProperties | undefined = fadeMask
    ? { WebkitMaskImage: fadeMask, maskImage: fadeMask }
    : undefined;
  const lines: CSSProperties = {
    WebkitMaskImage: CONTOURS_URL,
    maskImage: CONTOURS_URL,
    WebkitMaskSize: size,
    maskSize: size,
    WebkitMaskPosition: position,
    maskPosition: position,
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
  };

  return (
    <div aria-hidden="true" className={cn("pointer-events-none absolute", className)} style={outer}>
      <div className="h-full w-full bg-current" style={lines} />
    </div>
  );
}
